import { CIMSModule, CIMSPage, Permission } from '@cims-online/shared'
import { useProtectedMenuItem } from './useProtectedMenuItem'

export function useFDC() {
  return useProtectedMenuItem({
    module: CIMSModule.FDC,
    pages: [
      {
        page: CIMSPage.FDCTracker,
        permission: Permission.ViewFieldDesignChange,
      },
      {
        page: CIMSPage.FDCConcurrences,
        permission: [
          Permission.ViewFDCConcurrenceGroup,
          Permission.ViewFDCConcurrenceLevel,
        ],
      },
      {
        page: CIMSPage.FDCApprovalGroups,
        permission: Permission.ViewFDCApprovalGroup,
      },
      {
        page: CIMSPage.FDCDisciplines,
        permission: Permission.ViewFDCDiscipline,
      },
      {
        page: CIMSPage.FDCQuickLinks,
        permission: Permission.ViewFDCQuickLink,
      },
      {
        page: CIMSPage.FDCNotifications,
        permission: Permission.ViewFDCNotification,
      },
    ],
  })
}
